<mat-tab [label]="label">
  <ng-content></ng-content>
</mat-tab>
